import { Component, Input, OnInit } from '@angular/core';
import { FindCustomersGet } from '@app/services/customer.service';
import { CustomerItem, TypeaheadService } from '@app/services/typeahead.service';
import { getFindCustomersParams } from '../find-customers.params';

@Component({
    selector: 'tt-find-customers-list',
    templateUrl: './find-customers-list.component.html',
    styleUrls: ['./find-customers-list.component.css'],
    standalone: false,
})
export class FindCustomersListComponent implements OnInit {
    @Input()
    public page?: FindCustomersGet;

    public customers: CustomerItem[] = [];

    constructor(private typeahead: TypeaheadService) {}

    public async loadCustomers() {
        if (!this.page) return;

        this.customers = await this.typeahead.searchCustomer(getFindCustomersParams(this.page));
    }

    ngOnInit(): void {
        void this.loadCustomers();
    }
}
